export default __webpack_public_path__ + "static/media/DJI_0940.MP4.00_00_52_06.Still004.86a1a274.jpg";